<template>
  <b-container>
    <mercadolibre-list :type="type" />
  </b-container>
</template>
<script>
  import MercadolibreList from '@/components/MercadolibreList'
  export default {
    name: 'MercadolibrePage',
    title() {
      return this.$gettext('MercadoLibre')
    },
    components: {
      MercadolibreList
    },
    props: {
      type: {
        type: String,
        default: 'ongoing'
      }
    }
  }
</script>
